import { render, staticRenderFns } from "./CreateLevelView.vue?vue&type=template&id=4f206726&scoped=true&"
import script from "./CreateLevelView.vue?vue&type=script&lang=ts&"
export * from "./CreateLevelView.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLevelView.vue?vue&type=style&index=0&id=4f206726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f206726",
  null
  
)

export default component.exports